import { Component, OnInit, Input } from '@angular/core';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'itpx-evaluation-multi-content-deliverable-list',
  templateUrl: './evaluation-multi-content-deliverable-list.component.html',
  styleUrls: ['../../../workflow-new/common/style.css']
})
export class EvaluationMultiContentDeliverableListComponent extends RxComponent implements OnInit {
  @Input() deliverables$: Observable<any[]>;
  private sortedDeliverables$: Observable<any[]>;

  constructor() {
    super();
   }

  ngOnInit() {
    this.sortedDeliverables$ = this.deliverables$.map(deliverables => deliverables.sort((a, b) => a.order - b.order));
  }

  trackByFn(index, item) {
    return index; // or item.id
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/workflow_new/evaluation-multi-content-deliverable-list/evaluation-multi-content-deliverable-list.component.ts